import React from 'react';
import PropTypes from 'prop-types';

import { Table } from 'react-bootstrap';

import { connect } from 'react-redux';

import PlanRow from './row';

export function CommissionPlansTable({ plans, showArchivedPlans }) {
  const displayedPlans = plans.filter(plan => !plan.archived);
  
  if (showArchivedPlans) {
    displayedPlans.push(...plans.filter(plan => plan.archived));
  }
  
  return (
    <div className="backoffice-settings-table-wrapper sticky-actions">
      <Table responsive>
        <thead>
          <tr>
            <th>Plan Name</th>
            <th>Plan Type</th>
            <th className="start-date-cell">Reset Date</th>
            <th className="reset-period-cell">Reset Period</th>
            <th className="next-period-cell">Next Period Starts</th>
            <th className="tiers-cell">Tiers</th>
            <th>Assigned To</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {displayedPlans.map(plan => (
            <PlanRow key={plan.id} plan={plan} />
          ))}
        </tbody>
      </Table>
    </div>
  );
}

CommissionPlansTable.propTypes = {
  plans: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
  })).isRequired,
  showArchivedPlans: PropTypes.bool,
};

const mapStateToProps = state => ({
  showArchivedPlans: state.settings.showArchivedPlans,
  plans: state.plans,
});

export default connect(mapStateToProps)(CommissionPlansTable);
